import { Typography } from '@interstate/components/Typography';
import { Badge } from '@interstate/components/Badge';
import { Box } from '@interstate/components/Box';

import type { VehicleInfo } from './ItemRetentionConfirmationModal.types';
import { StyledVehicleCard } from './ItemRetentionConfirmationModal.styles';

const formatCondition = (condition?: string): string => {
    if (!condition) return '';
    const lower = condition.toLowerCase();
    if (lower === 'new') return 'New';
    if (lower === 'certified') return 'CPO';
    if (lower === 'used') return 'Used';
    return condition.charAt(0).toUpperCase() + condition.slice(1).toLowerCase();
};

export const VehicleCard = ({ vehicle, badge }: { vehicle: VehicleInfo; badge: 'current' | 'new' }) => {
    const badgeLabel = badge === 'current' ? 'Current' : 'New';
    const vehicleDescription = [formatCondition(vehicle.condition), vehicle.year, vehicle.make, vehicle.model, vehicle.trim]
        .filter(Boolean)
        .join(' ');

    return (
        <StyledVehicleCard $variant={badge} data-testid={`${badge}-vehicle-card`}>
            <Box>
                <Badge variant={badge === 'new' ? 'info' : 'white'} data-testid={`${badge}-vehicle`}>
                    {badgeLabel}
                </Badge>
            </Box>
            <Typography variant="strong-md" tag="div" className="vehicle-description" data-testid={`${badge}-vehicle-description`}>
                {vehicleDescription}
            </Typography>
            {vehicle.stockNumber && (
                <Typography variant="body-sm" data-testid={`${badge}-vehicle-stock`}>
                    <Typography variant="body-sm" tag="span" color="sem.color.on-surface.muted">
                        Stock#:
                    </Typography>{' '}
                    {vehicle.stockNumber}
                </Typography>
            )}
        </StyledVehicleCard>
    );
};
